export default __webpack_public_path__ + "static/media/css3.9d56f943.png";